import { Money } from "../api/types";

export function formatMoney(money: Money, locale: string = "de-DE"): string {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: money.currencyCode,
    }).format(parseFloat(money.amount));
}
